module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-9-0adf9bf198ca7e4400b81b84e68ba0b2.jpg";